import styled from 'styled-components';

export const MainContent = styled.main`
  padding: 20px 30px 50px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: column;

  .table {
    width: 100%;
    td:first-child {
      width: 100%;
    }
    td {
      width: 100px;
      font-size: 12px;
      font-weight: 500;
      line-height: 30px;
      text-align: left;
      color: var(--color-text-muted);
      padding: 10px 0;
    }
  }
`;
